<div type="button" data-test-id="messages-2AuthLvlPassed" (click)="is2AuthLvlPassed()">
  <div ngbDropdown autoClose="outside" class="notification-messenger" #dropdown="ngbDropdown">
    <span *ngIf="unreadChannelsCount > 0 && conversationsLoaded" class="notification-counter">{{
      unreadChannelsCount
    }}</span>
    <span
      class="d-inline-block"
      id="messenger-dropdown-toggle"
      data-test-id="messenger-dropdown-toggle"
      ngbDropdownToggle
      [ngStyle]="{
        'pointer-events': messengerEngineConnected ? 'auto' : 'none'
      }"
    >
      <svg-icon src="assets/icons/icon-messages.svg" class="icon-messages"> </svg-icon>
    </span>
    <div ngbDropdownMenu aria-labelledby="messenger-dropdown-toggle" class="notification-dropdown">
      <div *ngIf="!conversationsLoaded" data-test-id="messages-loading" ngbDropdownItem>
        {{ 'LOADING_HINT' | translate }}
      </div>
      <div *ngIf="conversationsLoaded">
        <div *ngIf="!messages?.length" data-test-id="messages-empty" class="messenger-empty">
          {{ 'MESSENGER_DONT_HAVE_MESSAGES' | translate }}
        </div>
        <div data-test-id="messages-loaded" *ngIf="messages?.length">
          <div *ngFor="let message of messages" ngbDropdownItem>
            <app-messenger-dropdown-item [message]="message"></app-messenger-dropdown-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
